// @flow
import type { MessageDescriptor } from 'react-intl';

export const REPORT_ORGANIZER_TYPE_CATALOGS = 'CATALOGS';
export const REPORT_ORGANIZER_TYPE_NP_SITES = 'NP_SITES';
export const REPORT_ORGANIZER_TYPE_NONE = 'NONE';

type ORG_TYPE = 'CATALOGS' | 'NP_SITES' | 'NONE';

// data used to create the various report forms
export type ReportFormConfig = {
  description?: MessageDescriptor,
  hasDateRange: boolean,
  label: MessageDescriptor,
  name: string,
  organizerType: ORG_TYPE,
  viewName: string,
};

// data used to run a report
export type ReportData = {
  name: string,
  catalogName?: string,
  catalogId?: string,
  isDownload?: boolean,
  siteId?: string,
  siteName?: string,
  startingDate?: string,
  endingDate?: string,
  viewName: string,
};



// WEBPACK FOOTER //
// ./src/state/types/reportTypes.js